// Redirect malformed links generated by GA
// Can't be a controller because the route parser won't match paths beginning with '?'

import { replaceUrl } from 'front-end-core/core/history'
import { includes, split } from 'libraries/lodash'
import getUrl from 'front-end-core/core/url'
import { DEFAULT_FLAVOUR } from 'front-end-core/constants/flavours'

export const GARedirect = queryString => {
  const hasHash = (typeof queryString === 'string') && queryString && includes(queryString, '#/')
  if (hasHash) {
    const [query = '', path = ''] = split(queryString, '#/')
    const redirectTo = query ? path + '?' + query : path
    replaceUrl(redirectTo)
    return true
  }
  return false
}

export const DefaultFlavourRedirect = (name, Controller) => (Router, evt, render) => {
  if (evt.params.flavour !== DEFAULT_FLAVOUR) {
    const { queryString } = evt
    const path = getUrl(name, { flavour: DEFAULT_FLAVOUR })
    const redirectTo = (typeof queryString === 'string') && queryString ? path + '?' + queryString : path
    replaceUrl(redirectTo)
    return redirectTo
  }
  return Controller(Router, evt, render)
}

export function UrlIdpRedirect () {
  return '/gw' + window.location.pathname + window.location.search
}
